import {
  Input,
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { SocketService } from '../../../../socket.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-temperature-mode-actuator',
  templateUrl: './temperature-mode-actuator.component.html',
  styleUrls: ['./temperature-mode-actuator.component.scss']
})
export class TemperatureModeActuatorComponent implements OnInit, OnDestroy {
  @Output() endpointChange: EventEmitter<any> = new EventEmitter();
  /**
   * Current node, parent of the endpoint.
   */
  @Input() node: any;
  @Input() endpoint: any;
  @Input() public status: boolean;

  public data: any;
  private ioConnectionActuation$: Subscription;

  public constructor(private socketService: SocketService) { }

  public ngOnInit() {
    this.data = { ...this.endpoint };
    if (!this.data.current) {
      this.data.current = 'Auto';
    }

    this.ioConnectionActuation$ = this.socketService
      .onActuationUpdated()
      .subscribe((measure: any) => {
        this.updateMeasure(measure);
      });
  }

  private updateMeasure(measure: any) {
    if (measure.device !== this.node._id || measure.endpoint !== this.data._id) {
      return;
    }

    this.data.current = measure.value;
  }

  public onChangeEndpoint(value: any) {
    this.data.current = value;
    this.endpointChange.emit({
      updated: true,
      _id: this.data._id,
      value: this.data.current
    });
  }

  public ngOnDestroy() {
    if (this.ioConnectionActuation$) {
      this.ioConnectionActuation$.unsubscribe();
    }
  }
}
